/* eslint-disable no-alert */
/* eslint-disable no-console */
import { Alert as BSAlert, Button, Col, Row, ToastContainer } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import alertSignal from 'signals/Alert.signal';

const Notification = ({ onCloseClick }) => (
  <ToastContainer
    position="top-end"
    className="p-0 position-fixed w-25"
    style={{ top: 15, right: 24, zIndex: 2000 }}
  >
    {alertSignal.value.notifications.map((notification) => (
      <BSAlert
        key={notification.id}
        variant={notification.variant ?? 'warning'}
        className="mb-8"
      >
        <Row className="justify-content-end">
          <Col sm="10">
            {notification.message}
          </Col>
          <Col sm="2" className="text-right">
            <FontAwesomeIcon
              icon={faTimes}
              onClick={() => onCloseClick(notification.id)}
              style={{ cursor: 'pointer' }}
            />
          </Col>
        </Row>
      </BSAlert>
    ))}
  </ToastContainer>
);

const Modal = ({ onCloseClick }) => (
  <div
    className="modal fade show modal-background"
    style={{ display: 'block' }}
    role="dialog"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content rounded-0 border-dark">
        <div className="modal-header bg-danger text-white rounded-0">
          An Error has occured!
        </div>
        <div className="modal-body" style={{ whiteSpace: 'pre-line' }}>
          {alertSignal.value.message}
        </div>
        <div className="modal-footer">
          <Button className="btn btn-dark" onClick={onCloseClick} type="button">
            {alertSignal.value.overrideCloseMessage || 'Close'}
          </Button>
        </div>
      </div>
    </div>
  </div>
);

const Alert = () => {
  if (alertSignal.value.error) {
    console.error(alertSignal.value.error);
  }

  const handleCloseClick = () => {
    if (alertSignal.value.onClose) {
      alertSignal.value.onClose();
    }
    alertSignal.reset();
  };

  const handleNotificationCloseClick = (id) => {
    alertSignal.update({
      notifications: alertSignal.value.notifications.filter(
        (notification) => notification.id !== id
      ),
    });
  };

  if (
    !alertSignal.value.notifications.length &&
    alertSignal.value.type !== 'alert'
  ) {
    return null;
  }

  // handles critical alerts
  if (alertSignal.value.type === 'alert') {
    return <Modal onCloseClick={handleCloseClick} />;
  }

  if (alertSignal.value.notifications.length) {
    return (
      <Notification
        notifications={alertSignal.value.notifications}
        onCloseClick={handleNotificationCloseClick}
      />
    );
  }

  return <div />;
};

export default Alert;
